import { isNullOrEmpty } from "../core/helpers/string-util.js";
import Account from "./Account.js";
import LedgerEntry from "./LedgerEntry.js";
import Model from "./Model.js";

/**
 * A simple transaction from a ledger entry.
 *
 * @param {{}} spec - Parameter object
 * @param {account} spec.account - Account linked to the transaction
 * @param {ledgerEntry} spec.ledgerEntry - Ledger entry to which the transaction belongs
 * @param {Date} spec.date - Date at which the transaction occurs
 * @param {number} spec.amount - Amount involved in thn transaction
 * @param {string} spec.text - Description of the transaction
 */
export default class Transaction extends Model {
	constructor(spec = {}) {
		super(spec);
		this._account = new Account(spec.account);
		this._ledgerEntry = new LedgerEntry(spec.ledgerEntry);
		this._date = spec.date;
		this._amount = spec.amount;
		this._text = spec.text;
	}

	getAccount() {
		return this._account;
	}

	setAccount(newAccount) {
		this._account = newAccount;
	}

	getLedgerEntry() {
		return this._ledgerEntry;
	}

	setLedgerEntry(newLedgerEntry) {
		this._ledgerEntry = newLedgerEntry;
	}

	getDate() {
		return this._date;
	}

	setDate(newDate) {
		this._date = newDate;
	}

	getAmount() {
		return this._amount;
	}

	getReversedAmount() {
		return this._reverse(this.getAmount());
	}

	setAmount(newAmount) {
		this._amount = newAmount;
	}

	getText() {
		return this._text;
	}

	setText(newText) {
		this._text = newText;
	}

	getTextOrLedgerEntryText() {
		if (isNullOrEmpty(this._text)) {
			return this._ledgerEntry.getText();
		}
		return this._text;
	}

	_reverse(amount) {
		return 0 - amount;
	}
}
